export const invoiceConstant = {
    GET_INVOICE_LOOKUP_PENDING: 'GET_INVOICE_LOOKUP_PENDING',
    GET_INVOICE_LOOKUP_SUCCESS: 'GET_INVOICE_LOOKUP_SUCCESS',
    GET_INVOICE_LOOKUP_FAILED: 'GET_INVOICE_LOOKUP_FAILED',
};
